import { HttpResult } from 'widgets-for-react'

const ensureLeadingSlash = (url: string) => (url.startsWith('/') ? url : '/' + url)

export const makeApiCall = async (
  slug: string,
  method: 'post' | 'get' = 'get',
  body: any = {}
): Promise<HttpResult<any>> => {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)

  let res: Response
  if (method == 'get') {
    res = await fetch(ensureLeadingSlash(slug), {
      method: method,
      credentials: 'include',
      headers: headers,
    })
  } else {
    res = await fetch(ensureLeadingSlash(slug), {
      method: method,
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(body),
    })
  }

  if (!res.ok) return { kind: "failed", status: 500 }
  try {
    const json = await res.json()
    return { kind: "result", status: 200, value: json }
  } catch {
    return { kind: "failed", status: 500 }
  }
}
